export default "__VITE_ASSET__CJ7UWdL9__"